import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { ProductDetail } from './pages/ProductDetail';
import { WhitehallProductTest } from './pages/WhitehallProductTest';
import { LegacyPreview } from './pages/LegacyPreview';
// Informational Pages
import { AboutUs } from './pages/info/AboutUs';
import { Services } from './pages/info/Services';
import { OurPolicies } from './pages/info/OurPolicies';
import { OurGallery } from './pages/info/OurGallery';
import { ContactUs } from './pages/info/ContactUs';
import { DominionValley } from './pages/info/DominionValley';
import { InstallInstructions } from './pages/info/InstallInstructions';
import { Catalog } from './pages/info/Catalog';
import { USPSResources } from './pages/info/USPSResources';
import { ProductOptionPatterns } from './pages/info/ProductOptionPatterns';
import { CATEGORY_SEO_PATHS, getCategoryForRoute } from './data/categoryRegistry';
import { ResidentialCategory } from './pages/ResidentialCategory';
export function App() {
  const categoryByRoute = (route: string) => {
    const entry = CATEGORY_SEO_PATHS.find(c => c.route === route);
    return entry ? getCategoryForRoute(entry) : undefined;
  };
  const addressPlaquesCategory = categoryByRoute('/6m8/address-plaques-and-house-numbers.html');
  const lightingCategory = categoryByRoute('/6m8/lighting.html');
  const replacementPartsCategory = categoryByRoute('/6m8/mailboxes/mailbox-replacement-parts-and-accessories.html');
  const centralizedCategory = categoryByRoute('/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html');
  const homeGardenCategory = categoryByRoute('/6m8/home-garden-accents.html');
  const commercialLocksCategory = categoryByRoute('/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html');
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/Home.html" element={<Home data-id="element-5" />} data-id="element-4" />

        {/* Informational Routes */}
        <Route path="/AboutMidAtlanticMailboxInc.html" element={<AboutUs data-id="element-7" />} data-id="element-6" />
        <Route path="/7.html" element={<AboutUs data-id="element-9" />} data-id="element-8" />

        <Route path="/Services.html" element={<Services data-id="element-11" />} data-id="element-10" />
        <Route path="/3947.html" element={<Services data-id="element-13" />} data-id="element-12" />

        <Route path="/OurPolicies" element={<OurPolicies data-id="element-15" />} data-id="element-14" />
        <Route path="/31.html" element={<OurPolicies data-id="element-17" />} data-id="element-16" />

        <Route path="/3949.html" element={<OurGallery data-id="element-19" />} data-id="element-18" />

        <Route path="/ContactUs.html" element={<ContactUs data-id="element-21" />} data-id="element-20" />
        <Route path="/5.html" element={<ContactUs data-id="element-23" />} data-id="element-22" />

        <Route path="/3948.html" element={<DominionValley data-id="element-25" />} data-id="element-24" />

        <Route path="/13.html" element={<InstallInstructions data-id="element-27" />} data-id="element-26" />

        <Route path="/29.html" element={<Catalog data-id="element-29" />} data-id="element-28" />

        <Route path="/USPSResources.html" element={<USPSResources data-id="element-31" />} data-id="element-30" />

        <Route path="/product-option-patterns.html" element={<ProductOptionPatterns data-id="element-33" />} data-id="element-32" />

        {/* Product Routes */}
        <Route path="/m8/4C16D-20-D--versatile-4c-depot-16h-20-door-package.html" element={<ProductDetail data-id="element-35" />} data-id="element-34" />
        <Route path="/whitehall-product-test" element={<WhitehallProductTest data-id="element-37" />} data-id="element-36" />

        {/* All visible category/listing routes (recognized before the legacy
            fallback, even when a route has no sample product data yet). */}
        {CATEGORY_SEO_PATHS.map(entry => <Route key={entry.route} path={entry.route} element={<ResidentialCategory category={getCategoryForRoute(entry)} context={entry.context} data-id="element-39" />} data-id="element-38" />)}

        {/* Commercial aliases */}
        {centralizedCategory && <Route path="/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-kiosks.html" element={<ResidentialCategory category={centralizedCategory} context="Commercial" data-id="element-41" />} data-id="element-40" />}
        {commercialLocksCategory && <Route path="/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-and-doors.html" element={<ResidentialCategory category={commercialLocksCategory} context="Commercial" data-id="element-43" />} data-id="element-42" />}
        {/* Alias for Replacement Parts (cleaner path) */}
        {replacementPartsCategory && <Route path="/6m8/mailboxes/mailbox-replacement-parts.html" element={<ResidentialCategory category={replacementPartsCategory} context="Residential" data-id="element-45" />} data-id="element-44" />}

        {/* Signs & Accents aliases */}
        {addressPlaquesCategory && <Route path="/6m8/address-plaques.html" element={<ResidentialCategory category={addressPlaquesCategory} context="Signs & Accents" data-id="element-47" />} data-id="element-46" />}
        {/* Preview alias for the lighting outdoor/exterior subcategory */}
        {lightingCategory && <Route path="/preview/6m8/lighting/outdoor-exterior-lighting.html" element={<ResidentialCategory category={lightingCategory} context="Signs & Accents" data-id="element-49" />} data-id="element-48" />}
        {/* Optional Site Furnishings quick-link alias → Home & Garden data */}
        {homeGardenCategory && <Route path="/6m8/home-garden-accents/outdoor-furnishings-and-fire-tables.html" element={<ResidentialCategory category={homeGardenCategory} context="Signs & Accents" data-id="element-51" />} data-id="element-50" />}

        {/* Catch-all */}
        <Route path="*" element={<LegacyPreview data-id="element-53" />} data-id="element-52" />
      </Routes>
    </BrowserRouter>;
}